var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "carousel-selection",
    class: {
      'carousel-selection--has-error': _vm.hasError,
      'carousel-selection--disabled': _vm.disabled
    }
  }, [_vm.isFetchingData ? _c('div', {
    staticClass: "carousel-selection-field carousel-selection-field--is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('div', {
    staticClass: "carousel-selection-field",
    on: {
      "click": _vm.handleFieldIsClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForField) + " "), _c('svg', {
    attrs: {
      "width": "19",
      "height": "18",
      "viewBox": "0 0 19 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.38672 13.4707C9.62402 13.4707 9.85254 13.374 10.0107 13.1982L16.418 6.6416C16.5674 6.49219 16.6553 6.29004 16.6553 6.06152C16.6553 5.5957 16.2949 5.23535 15.8291 5.23535C15.6094 5.23535 15.3984 5.32324 15.2402 5.47266L9.39551 11.458L3.54199 5.47266C3.38379 5.32324 3.18164 5.23535 2.94434 5.23535C2.47852 5.23535 2.11816 5.5957 2.11816 6.06152C2.11816 6.29004 2.20605 6.49219 2.36426 6.65039L8.77148 13.1982C8.94727 13.374 9.14941 13.4707 9.38672 13.4707Z",
      "fill": "var(--liff-primary_text_color)"
    }
  })])]), _c('b-modal', {
    ref: "carousel",
    attrs: {
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', {
          staticClass: "carousel-selection-modal",
          style: _vm.colorObject
        }, [_c('button', {
          staticClass: "carousel-selection-modal__close",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/images/close.svg")
          }
        })]), _vm.candidates.length > 0 ? _c('div', [_c('swiper', {
          ref: "swiper",
          attrs: {
            "options": _vm.swiperOption
          },
          nativeOn: {
            "click": function click($event) {
              return _vm.sliderClicked.apply(null, arguments);
            }
          }
        }, _vm._l(_vm.candidates, function (candidate, idx) {
          return _c('swiper-slide', {
            key: "".concat(_vm.renderCount, "-").concat(idx)
          }, [_c('div', {
            staticClass: "badge__detail__hero"
          }, [_c('div', {
            staticClass: "badge__detail__hero__img"
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: candidate.loaded,
              expression: "candidate.loaded"
            }],
            staticClass: "img-fluid",
            attrs: {
              "src": candidate.image
            },
            on: {
              "load": function load($event) {
                candidate.loaded = true;
              }
            }
          }), candidate.image && !candidate.loaded ? _c('div', {
            staticClass: "text-center p-4"
          }, [_c('b-spinner', {
            attrs: {
              "variant": "secondary"
            }
          })], 1) : _vm._e()])]), _c('div', {
            staticClass: "py-3 border-bottom px-4"
          }, [_c('div', {
            staticClass: "badge__detail__hero__title mt-2"
          }, [_vm._v(_vm._s(candidate.title))]), _c('div', {
            domProps: {
              "innerHTML": _vm._s(candidate.description)
            }
          })]), _c('div', {
            staticClass: "py-3"
          }, [_c('SharedButton', {
            staticClass: "s-btn-bg-primary carousel-selection__select-button"
          }, [_vm._v("選擇")])], 1)]);
        }), 1), _c('div', {
          staticClass: "swiper-button-prev",
          on: {
            "click": _vm.decreaseViewingCandidateIndex
          }
        }), _c('div', {
          staticClass: "swiper-button-next",
          on: {
            "click": _vm.increaseViewingCandidateIndex
          }
        })], 1) : _c('div', [_c('div', {
          staticClass: "text-center p-4"
        }, [_vm._v(" 查無資料 ")])])])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }